import { render, staticRenderFns } from "./CreditManagement.vue?vue&type=template&id=10c081d0&"
import script from "./CreditManagement.vue?vue&type=script&lang=js&"
export * from "./CreditManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports